module.exports = __webpack_public_path__ + "media/images/empty-activities-dbd6807cd4593067fb6b141b698b470d.png";